import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHiringProcess } from '../../context/HiringProcessContext';
import { useTranslation } from 'react-i18next';

function Page4_Launch() {
  const {
    jobTitle,
    createdJd,
    simulationLaunched,
    handleLaunchSimulation,
    isLaunching,
    allTeamMembersProvidedInput,
    processedJd,
    setStep
  } = useHiringProcess();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (simulationLaunched) {
      const timer = setTimeout(() => {
        navigate('/welcome');
      }, 3000); // 3-second delay

      return () => clearTimeout(timer);
    }
  }, [simulationLaunched, navigate]);

  const handleDone = () => {
    navigate('/welcome');
  };

  const handleGoBack = () => {
    setStep(3);
    navigate('/start-hiring/team');
  };

  const teamMembersAssigned = createdJd && createdJd.teamMembers && createdJd.teamMembers.length > 0;

  return (
    <div className="li-card" style={{ padding: '24px' }}>
      <div style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>{jobTitle}</h2>
        <span style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)' }}>Step 3: Launch</span>
      </div>
      
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>{t('startHiring.step3Title')}</h3>
        
        {teamMembersAssigned && (
          <div style={{ marginBottom: '24px', backgroundColor: '#f9fafb', padding: '16px', borderRadius: '8px' }}>
            <h4 style={{ fontSize: '14px', fontWeight: '600', margin: '0 0 12px 0' }}>{t('startHiring.teamStatusTitle')}</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {createdJd.teamMembers.map(member => (
                <li key={member.uid} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #e0e0e0', fontSize: '14px' }}>
                  <span style={{ color: 'rgba(0,0,0,0.9)' }}>{member.email}</span>
                  <span style={{ 
                    fontWeight: '600', 
                    color: member.status === 'input_provided' ? '#057642' : '#e7a33e' 
                  }}>
                    {t(`startHiring.status.${member.status.replace('_', '')}`)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div style={{ padding: '16px', backgroundColor: '#e8f0fe', borderRadius: '8px', color: '#0a66c2', fontSize: '14px', fontWeight: '500' }}>
          {simulationLaunched ? (
            <span style={{ color: '#057642' }}>{t('startHiring.launchSuccessMessage')}</span>
          ) : (
            <span>
              {teamMembersAssigned
                ? (allTeamMembersProvidedInput()
                  ? t('startHiring.allInputProvided')
                  : t('startHiring.waitingForInput'))
                : "No team members assigned. Simulation is ready to launch."
              }
            </span>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px', borderTop: '1px solid #e0e0e0', paddingTop: '16px' }}>
        <button onClick={handleGoBack} className="li-btn-outline-secondary" style={{ width: 'auto' }}>Go Back</button>
        <div>
          {teamMembersAssigned && !allTeamMembersProvidedInput() && (
            <button onClick={handleDone} className="li-btn-primary">Done</button>
          )}
          {(!teamMembersAssigned || allTeamMembersProvidedInput()) && (
            <button 
                onClick={handleLaunchSimulation} 
                className="li-btn-primary" 
                disabled={!processedJd || isLaunching || simulationLaunched}
                style={simulationLaunched ? { backgroundColor: '#e3f2fd', color: '#0a66c2', borderColor: '#e3f2fd', cursor: 'default' } : {}}
            >
              {isLaunching ? t('startHiring.launching') : (simulationLaunched ? t('startHiring.launched') : t('startHiring.launchButton'))}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Page4_Launch;